enum EStatus {
  Active = 'Active',
  Scheduled = 'Scheduled',
  Expired = 'Expired',
}
export { EStatus };
